import { V2BookingStatus } from '@/api/clients/ohip';
import { isBookingConfirmed } from '@/booking/helpers/status';

import { ReservationStatus } from './ReservationStatus.enum';

/**
 * Returns the http://schema.org representation of the given booking state.
 * @param booking
 */
export const getReservationStatusForBooking = (
  status: V2BookingStatus,
  isPaymentBeingTaken: boolean
): ReservationStatus => {
  if (isBookingConfirmed(status)) {
    return ReservationStatus.Confirmed;
  }

  if (isPaymentBeingTaken) {
    return ReservationStatus.Pending;
  }

  return ReservationStatus.Hold;
};
